import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import Tools from '@/components/tools/Tools.js'
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
// import {mask} from 'vue-the-mask'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin.js'
import localStoreHelper from '@/shared/utils/localStoreHelper'

const name = 'CollaboratorTableTravelExpense'

export default {
  name,
  mixins: [ActionsForm, ExpenseMixin],
  components: {
    AutocompleteZ
  },

  props: {
    // Quando true (tela de CONSULTA de Despesa Viagem) o componente e read-only:
    // esconde o gerar pedido da grid. Mesma prop do par em tablepaidlots do Diversos.
    isConsulta: {
      type: Boolean,
      default: false
    }
  },

  updated () { },

  data () {
    return {
      pedido: null,
      PedidoGerado: false,
      ArrayLotePagos: [],
      dataSearch: localStoreHelper.viagem.lotesPagos() || {},
      local: ''
    }
  },
  mounted () {
    this.Onload()
    this.GetEmpresa()
  },

  methods: {
    GetEmpresa () {
      TravelExpenseRepository.GetEmpresa(this.CompanySelected)
        .then(Response => {
          this.local = Response.data.localidade
          this.$emit('localidade', this.local)
        })
    },
    onSelect (data) {
      // consulta=1 propaga o read-only pra tela de detalhe, que e rota separada (prop nao chega la)
      this.$router.push(`/lotes/pagos/detalhes/lote?lote=${data}${this.isConsulta ? '&consulta=1' : ''}`)
    },
    Onload () {
      loading.push()
      if (this.dataSearch.Lote != null || this.dataSearch.DataLote != null || this.dataSearch.FuncionarioId != null) {
        if (this.dataSearch.Lote != null) {
          this.dataSearch.Lote = parseInt(this.dataSearch.Lote)
        }
        this.dataSearch.EmpresaID = this.CompanySelected
        // if (this.dataSearch.DataLote != null) {
        //   this.dataSearch.DataLote = new Date(this.dataSearch.DataLote)
        // }

        TravelExpenseRepository.GetLotesPagosByFilter(this.$refs.tableGridLotePago.pagingLimit, this.$refs.tableGridLotePago.pagingIndex, this.dataSearch)
          .then((Response) => {
            this.ArrayLotePagos = Response.data.data
            this.$refs.tableGridLotePago.LoadAllByData(Response)
            loading.close()
          })
          .catch((Error) => {
            loading.pop()
            toast.error('error!')
          })
      } else {
        TravelExpenseRepository.getLotePago(this.CompanySelected, this.$refs.tableGridLotePago.pagingLimit, this.$refs.tableGridLotePago.pagingIndex)
          .then((Response) => {
            this.ArrayLotePagos = Response.data.data
            this.$refs.tableGridLotePago.LoadAllByData(Response)
            loading.close()
          })
          .catch((Error) => {
            loading.pop()
            toast.error('error!')
          })
      }
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    formataData (value) {
      if (value != null) {
        var data = new Date(value)
        var dia = data.getDate()
        var mes = data.getMonth() + 1
        var ano = data.getFullYear()
        var dataFormatada = dia.toString().padStart(2, '0') + '/' + mes.toString().padStart(2, '0') + '/' + ano
        return dataFormatada
      } else {
        return 'N/D'
      }
    },
    // ZC-81: a planilha que o GERAR LOTE baixou uma vez fica gravada no lote; aqui baixa a mesma de novo
    baixarExcelLote (data) {
      loading.push()
      TravelExpenseRepository.ArquivoLote(data.id, this.CompanySelected)
        .then((Response) => {
          loading.pop()
          const r = Response.data
          if (!r || r.code !== 200 || !r.data) {
            toast.error((r && r.message) || 'Planilha do lote não encontrada.')
            return
          }
          const bytes = Uint8Array.from(atob(r.data.file), c => c.charCodeAt(0))
          const a = window.document.createElement('a')
          a.href = window.URL.createObjectURL(new Blob([bytes], { type: r.data.contentType }))
          a.download = r.data.name || `lote-${data.lote}.xlsx`
          document.body.appendChild(a)
          a.click()
          a.remove()
          setTimeout(() => window.URL.revokeObjectURL(a.href), 1000)
        })
        .catch(() => {
          loading.pop()
          toast.error('Não foi possível baixar a planilha do lote.')
        })
    },
    showModalPedido (loteId) {
      console.log(loteId)
      this.loteId = loteId.id
      this.PedidoGerado = false
      this.$refs['ModalGerarPedido'].show()
    },
    cancelPedido () {
      this.loteId = null
      this.$refs['ModalGerarPedido'].hide()
    },
    showModalPedidoGerado () {
      loading.push()
      TravelExpenseRepository.GerarPedido({LoteId: this.loteId, FuncionarioId: null, EmpresaId: this.CompanySelected})
        .then((Response) => {
          loading.close()
          this.pedido = Response.data
          this.PedidoGerado = true
        })
        .catch((Error) => {
          toast.error('Erro ao gerar pedido!')
          loading.close()
          this.$refs['ModalGerarPedido'].hide()
        })
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/finance/expenses/travelexpensezpag/components/Tabs/LotsPaid/LotsPaid.js